<template>
    <div class="textElementOptions">
        <div class="color_picker_btn">
            <colorPickerTest/>
        </div>
        <div class="font_family_btn tooltipElement">
            <toggleOption >
                <template #toggleTitle>
                    {{ getActiveElement.font.family }}
                    <inline-svg
                        :src="arrow_down"
                        fill="#737373"
                    />
                </template>
                <fontFamilyPick/>
            </toggleOption>
            <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsFontFamily') }`" />
        </div>
        <div class="font_weight_btn tooltipElement">
            <toggleOption>
                <template #toggleTitle>
                    {{ getActiveElement.font.weight.name }}
                    <inline-svg
                        :src="arrow_down"
                        fill="#737373"
                    />
                </template>
                <fontWeightPick/>
            </toggleOption>
            <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsFontWeight') }`" />
        </div>
        <div class="font_size_btn tooltipElement">
            <fontSizePick/>
            <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsFontSize') }`" />
        </div>
        <div class="text_align_btns tooltipElement">
            <textAlign
                v-for="(direction, index) in alignDirections"
                :key="index"
                :direction="direction.name"
                :alignIcon="direction.icon"
            />
            <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsTextAlign') }`" />
        </div>
        <div class="text_decoration_btns">
            <textDecoration
                v-for="(value, name) in decorations"
                :key="name"
                :decorationName="name"
                :decorateIcon="value.icon"
            />
        </div>
        <textPlaceholders v-if="this.getSessionDetails.mode === 'merchant'" />
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import Tooltip from '@/components/Global/Tooltip.vue';
    import colorPickerTest from './colorPickerTest.vue';
    import toggleOption from './toggleOption.vue';
    import fontFamilyPick from './textOptions/fontFamilyPick.vue';
    import fontWeightPick from './textOptions/fontWeightPick.vue';
    import fontSizePick from './textOptions/fontSizePick.vue';
    import textAlign from './textOptions/textAlign.vue';
    import textPlaceholders from './placeholders.vue';
    import text_align_center_icon from '@/assets/icons/text_align_center.svg';
    import text_align_right_icon from '@/assets/icons/text_align_right.svg';
    import text_align_left_icon from '@/assets/icons/text_align_left.svg';
    import textDecoration from './textOptions/textDecoration.vue';
    import text_decoration_capitals_icon from '@/assets/icons/text_decoration_capitals.svg';
    import text_decoration_underline_icon from '@/assets/icons/text_decoration_underline.svg';
    import arrow_down from '@/assets/icons/arrow_down_full.svg';

    export default {
        data() {
            return {
                arrow_down,
                alignDirections: [
                    {
                        name: 'left',
                        icon: text_align_left_icon
                    },
                    {
                        name: 'center',
                        icon: text_align_center_icon
                    },
                    {
                        name: 'right',
                        icon: text_align_right_icon
                    }
                ],
                decorations: {
                    capitals: {
                        icon: text_decoration_capitals_icon
                    },
                    underline: {
                        icon: text_decoration_underline_icon
                    }
                }
            }
        },
        computed: {
            ...mapGetters([
                'activeElement',
                'getActiveElement',
                'getSessionDetails'
            ])
        },
        components: {
            colorPickerTest,
            toggleOption,
            fontFamilyPick,
            fontWeightPick,
            fontSizePick,
            textAlign,
            textDecoration,
            textPlaceholders,
            Tooltip
        }
    }
</script>

<style lang="scss">
    .textElementOptions {
        display: flex;
        flex-grow: 1;
    }
    .textElementOptions > div {
        position: relative;
        border-right: 1px solid #D4D4D4;
    }
    .text_align_btns,
    .text_decoration_btns {
        display: flex;
    }
    .color_picker_btn {
        width: 120px;
    }
    .font_family_btn,
    .font_weight_btn {
        width: 12%;
    }
    .font_family_btn .toggle_option-trigger,
    .font_weight_btn .toggle_option-trigger {
        justify-content: space-between;
    }
    .font_size_btn {
        width: 6%;
        box-sizing: border-box;
        font-size: 12px;
        padding: 6px;
    }
    @media (max-width: 1200px) {
        .color_picker_btn {
            width: 125px;
        }
        .font_family_btn,
        .font_weight_btn {
            width: 80px;
        }
        .font_size_btn {
            width: 80px;
        }
    }
</style>
